import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-screen bg-white" }
const _hoisted_2 = { class: "max-w-sm mx-auto md:mt-8 p-4 md:border md:border-gray-300 rounded md:shadow-md" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "w-full px-3 py-2 bg-black text-white rounded"
}, " Register ", -1)
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = ["textContent"]

import { ref} from 'vue';
  import { useRouter } from 'vue-router'
  import { useCurrentCompanyStore } from '../stores/CurrentCompanyStore'
  import { useUserStore } from '../stores/UserStore'
  import { storeToRefs } from 'pinia'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterPage',
  setup(__props) {

  const {register } = useUserStore()
  const router = useRouter()
  const {currentCompanyId } = storeToRefs(useCurrentCompanyStore())
  const {userEmail, userFirstName, userLastName, userPhoneNumber,userCompanyId,userId,userRole } = storeToRefs(useUserStore())
  
  let email= ref("")
  let firstname=ref("")
  let phoneNumber=ref("")
  let password= ref("")
  let password2= ref("")
  let message= ref("")


  async function registration(){
    if (password.value !== password2.value) {
      message.value = "The passwords don't match";
      return;
    }
    const _registration = await register(email.value,password.value,firstname.value,phoneNumber.value);
    if (_registration){
      if (Number(currentCompanyId.value) !== 0) {
        router.push(`/company/${currentCompanyId.value}`);
      } else {
        router.push(`/`);
      }
    }
    else{
      message.value = "wrong email/password";
    }
  }

  // async function register() {
  //   if (password.value !== password2.value) {
  //       message.value = "The passwords don't match";
  //       return;
  //   }

  //   try {
  //       const response = await fetch(`${process.env.VUE_APP_API_BASE}/api/Auth/register`, {
  //           method: "POST",
  //           headers: {
  //               'Content-Type': 'application/json',
  //           },
  //           credentials: 'include',
  //           body: JSON.stringify({
  //               Email: email.value,
  //               Password: password.value
  //           })
  //       });

  //       if (response.ok) {
  //           const responseJSON = await response.json();
  //           userEmail.value=responseJSON.email;
  //           userFirstName.value=responseJSON.firstName;
  //           userLastName.value=responseJSON.lastName;
  //           userPhoneNumber.value=responseJSON.phoneNumber;
  //           userCompanyId.value=responseJSON.companyID;
  //           userRole.value=responseJSON.role;
  //           userId.value=responseJSON.userId;

  //           if (Number(currentCompanyId.value) !== 0) {
  //               router.push(`/company/${currentCompanyId.value}`);
  //           } else {
  //               router.push(`/`);
  //           }
  //       } else {
  //           const errorMessage = await response.text();
  //           console.error(`Request failed with status ${response.status}: ${errorMessage}`);
  //           message.value = errorMessage;
  //       }
  //   } catch (error) {
  //       console.error(error);
  //   }
  // }
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(registration, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "firstname",
            placeholder: "Prénom",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(firstname) ? (firstname).value = $event : firstname = $event)),
            required: "",
            class: "w-full px-3 py-2 border rounded"
          }, null, 512), [
            [_vModelText, _unref(firstname)]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "phoneNumber",
            placeholder: "Téléphone",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(phoneNumber) ? (phoneNumber).value = $event : phoneNumber = $event)),
            required: "",
            class: "w-full px-3 py-2 border rounded"
          }, null, 512), [
            [_vModelText, _unref(phoneNumber)]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "email",
            id: "email",
            placeholder: "Email",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(email) ? (email).value = $event : email = $event)),
            required: "",
            class: "w-full px-3 py-2 border rounded"
          }, null, 512), [
            [_vModelText, _unref(email)]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "password",
            id: "password",
            placeholder: "Mot de Passe",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(password) ? (password).value = $event : password = $event)),
            required: "",
            class: "w-full px-3 py-2 border rounded"
          }, null, 512), [
            [_vModelText, _unref(password)]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "password",
            id: "password2",
            placeholder: "Mot de Passe",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(password2) ? (password2).value = $event : password2 = $event)),
            required: "",
            class: "w-full px-3 py-2 border rounded"
          }, null, 512), [
            [_vModelText, _unref(password2)]
          ])
        ]),
        _hoisted_9
      ], 40, _hoisted_3),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", {
            id: "message",
            textContent: _toDisplayString(_unref(message)),
            class: "w-full text-red-500 text-center"
          }, null, 8, _hoisted_12)
        ])
      ])
    ])
  ]))
}
}

})